import Types from "./Types";
/* eslint-disable camelcase */

/************************************************
Get Requests
*************************************************/

const getRequests = query => {
  return { type: Types.GET_REQUESTS, query };
};

const getRequestsSuccess = pending => ({
  type: Types.GET_REQUESTS_SUCCESS,
  pending
});

const getRequestsFailure = error => ({
  type: Types.GET_REQUESTS_FAILURE,
  error
});

/************************************************
getStocksCount
*************************************************/

const getStocksCount = query => {
  return { type: Types.GET_STOCKS_COUNT, query };
};

const getStocksCountSuccess = stocksCount => ({
  type: Types.GET_STOCKS_COUNT_SUCCESS,
  stocksCount
});

const getStocksCountFailure = error => ({
  type: Types.GET_STOCKS_COUNT_FAILURE,
  error
});

/************************************************
getPicklists
*************************************************/

const getPicklists = query => {
  return { type: Types.GET_PICKLISTS, query };
};

const getPicklistsSuccess = picklists => ({
  type: Types.GET_PICKLISTS_SUCCESS,
  picklists
});

const getPicklistsFailure = error => ({
  type: Types.GET_PICKLISTS_FAILURE,
  error
});

/************************************************
getPicklistItems
*************************************************/

const getPicklistItems = query => {
  return { type: Types.GET_PICKLIST_ITEMS, query };
};

const getPicklistItemsSuccess = picklistItems => ({
  type: Types.GET_PICKLIST_ITEMS_SUCCESS,
  picklistItems
});

const getPicklistItemsFailure = error => ({
  type: Types.GET_PICKLIST_ITEMS_FAILURE,
  error
});

/************************************************
getPicklistItems
*************************************************/

const getReadyForPickup = query => {
  return { type: Types.GET_READY_FOR_PICKUP, query };
};

const getReadyForPickupSuccess = readyForPickup => ({
  type: Types.GET_READY_FOR_PICKUP_SUCCESS,
  readyForPickup
});

const getReadyForPickupFailure = error => ({
  type: Types.GET_READY_FOR_PICKUP_FAILURE,
  error
});

/************************************************
createPicklist
*************************************************/

const createPicklist = payload => {
  return { type: Types.CREATE_PICKLIST, payload };
};

const createPicklistSuccess = () => ({
  type: Types.CREATE_PICKLIST_SUCCESS
});

const createPicklistFailure = error => ({
  type: Types.CREATE_PICKLIST_FAILURE,
  error
});

/************************************************
updatePicklistQty
*************************************************/

const updatePicklistQty = payload => {
  return { type: Types.UPDATE_PICKLIST_QTY, payload };
};

const updatePicklistQtySuccess = () => ({
  type: Types.UPDATE_PICKLIST_QTY_SUCCESS
});

const updatePicklistQtyFailure = error => ({
  type: Types.updatePicklistQtyFailure,
  error
});

/************************************************
markReadyForPickup
*************************************************/

const markReadyForPickup = payload => {
  return { type: Types.MARK_READY_FOR_PICKUP, payload };
};

const markReadyForPickupSuccess = () => ({
  type: Types.MARK_READY_FOR_PICKUP_SUCCESS
});

const markReadyForPickupFailure = error => ({
  type: Types.MARK_READY_FOR_PICKUP_FAILURE,
  error
});

/************************************************
markOutOfStock
*************************************************/

const markOutOfStock = (payload, noLoad) => {
  return { type: Types.MARK_OUT_OF_STOCK, payload, noLoad };
};

const markOutOfStockSuccess = () => ({
  type: Types.MARK_OUT_OF_STOCK_SUCCESS
});

const markOutOfStockFailure = error => ({
  type: Types.MARK_OUT_OF_STOCK_FAILURE,
  error
});

export {
  getRequests,
  getRequestsSuccess,
  getRequestsFailure,
  createPicklist,
  createPicklistSuccess,
  createPicklistFailure,
  getPicklists,
  getPicklistsSuccess,
  getPicklistsFailure,
  getPicklistItems,
  getPicklistItemsSuccess,
  getPicklistItemsFailure,
  markReadyForPickup,
  markReadyForPickupSuccess,
  markReadyForPickupFailure,
  getReadyForPickup,
  getReadyForPickupSuccess,
  getReadyForPickupFailure,
  updatePicklistQty,
  updatePicklistQtySuccess,
  updatePicklistQtyFailure,
  getStocksCount,
  getStocksCountSuccess,
  getStocksCountFailure,
  markOutOfStock,
  markOutOfStockSuccess,
  markOutOfStockFailure
};



// WEBPACK FOOTER //
// ./src/actions/StockRequestActions.js